import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/prospecting-search/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import EmailPower from "../components/prospecting-search/EmailPower";
import Benefits from "../components/prospecting-search/Benefits";
import Cta from "../components/prospecting-search/Cta";
import Testimonials from "../components/prospecting-search/Testimonials";

const ProspectingSearch = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <EmailPower />
      <Benefits />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default ProspectingSearch;

